import { render } from "./PreloaderView.vue?vue&type=template&id=ba501c4e&scoped=true&ts=true"
import script from "./PreloaderView.vue?vue&type=script&lang=ts"
export * from "./PreloaderView.vue?vue&type=script&lang=ts"

import "./PreloaderView.vue?vue&type=style&index=0&id=ba501c4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba501c4e"]])

export default __exports__